// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import loadCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCart";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { getCurrentCountries } from "@insite/client-framework/Store/Data/Countries/CountriesSelectors";
import loadCurrentCountries from "@insite/client-framework/Store/Data/Countries/Handlers/LoadCurrentCountries";
import loadCurrentPromotions from "@insite/client-framework/Store/Data/Promotions/Handlers/LoadCurrentPromotions";
import loadPromotions from "@insite/client-framework/Store/Data/Promotions/Handlers/LoadPromotions";
import {
    getCurrentPromotionsDataView,
    getPromotionsDataView,
} from "@insite/client-framework/Store/Data/Promotions/PromotionsSelectors";
import {
    chain,
    LoadData,
} from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/LoadDataIfNeeded";
import setExpressCartStatus from "@mcmc/App/Handlers/Pages/Checkout/SetExpressCartStatus";

export const CustomLoadData: typeof LoadData = props => {
    const state = props.getState();
    if (!getCurrentCountries(state)) {
        props.dispatch(loadCurrentCountries());
    }
    const expand = state.data.carts.cartApiParameter?.expand || [];
    if (props.parameter.cartId) {
        const cartState = getCartState(state, props.parameter.cartId);
        if (
            (!cartState.value ||
                !cartState.value.paymentOptions ||
                !expand.includes("shipping") ||
                !expand.includes("tax")) &&
            !cartState.isLoading
        ) {
            const promotionsState = getPromotionsDataView(state, props.parameter.cartId);
            const shouldLoadPromotions = !promotionsState.value && !promotionsState.isLoading;
            props.dispatch(loadCart({ cartId: props.parameter.cartId, getPromotions: shouldLoadPromotions }));
        }
        const promotionsState = getPromotionsDataView(state, props.parameter.cartId);
        if (!promotionsState.value && !promotionsState.isLoading) {
            props.dispatch(loadPromotions({ cartId: props.parameter.cartId }));
        }
    } else {
        const isExpressCheckout: boolean = (props.parameter as any).isExpressCheckout;
        const currentCartState = getCurrentCartState(state);
        if (
            isExpressCheckout ||
            ((!currentCartState.value ||
                !currentCartState.value.paymentOptions ||
                !expand.includes("shipping") ||
                !expand.includes("tax")) &&
                !currentCartState.isLoading)
        ) {
            if (isExpressCheckout) {
                props.dispatch(setExpressCartStatus({ isLoaded: false }));
            }

            const currentPromotionsState = getCurrentPromotionsDataView(state);
            const shouldLoadPromotions = !currentPromotionsState.value && !currentPromotionsState.isLoading;
            props.dispatch(
                loadCurrentCart({
                    getPromotions: shouldLoadPromotions,
                    onCanceled: () => {
                        if (isExpressCheckout) {
                            props.dispatch(setExpressCartStatus({ isLoaded: true }));
                        }
                    },
                    onSuccess: () => {
                        if (isExpressCheckout) {
                            props.dispatch(setExpressCartStatus({ isLoaded: true }));
                        }
                    },
                    expand: isExpressCheckout ? ["defaultPaymentMethod"] : [],
                } as any),
            );
        }
    }
};

replaceInChain(chain, LoadData, CustomLoadData);
